// @ts-nocheck
import { AuthProvider, ProtectedElement } from '@praxis/component-auth'
import { AnalyticsProvider } from '@praxis/component-analytics'
import { GlobalProvider } from 'context/GlobalContext'
import { EnvProvider } from '@praxis/component-runtime-env'
import { ErrorBoundary } from '@praxis/component-logging'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import apiConfig from 'config/apiConfig'
import { GlobalStyle } from './common/globalStyles'
import OfflineDialog from './components/OfflineDialog'
import { Main } from './components/Main/Main'
import { Unauthorized } from './components/Unauthorized/Unauthorized'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-autocomplete'
import '@enterprise-ui/canvas-ui-css-datepicker'
import { JoyrideProvider } from './context/JoyrideContext'
import { UpdatesNotification } from 'UpdatesNotification'
import { UpdatesAvailableProvider } from 'UpdatesAvailableContext'
import { ToastProvider } from '@enterprise-ui/canvas-ui-react'
import { BrowserRouter as Router } from 'react-router-dom'
import {
  OpenTelemetryConfig,
  OpenTelemetryManager,
} from '@measurement/opentelemetry-web'

const queryClient = new QueryClient({})

const App = () => {
  const config: OpenTelemetryConfig = {
    apiKey: String(apiConfig.metrics.key),
    serviceName: 'shipiq',
    globalLogLevel: 'INFO',
  }
  OpenTelemetryManager.initialize(config)

  return (
    <ErrorBoundary>
      <EnvProvider configPath="/config.json">
        <AuthProvider
          clientId={apiConfig.auth?.clientId}
          authorizationUrl={apiConfig.auth?.authorizationUrl}
          logoutUrl={apiConfig.auth?.logoutUrl}
        >
          <AnalyticsProvider eventManagerConfiguration={apiConfig.analytics}>
            <UpdatesAvailableProvider>
              <GlobalStyle />
              <GlobalProvider>
                <JoyrideProvider>
                  <ToastProvider>
                    <QueryClientProvider client={queryClient}>
                      <Router>
                        <ProtectedElement
                          allowed={[
                            ...apiConfig.entitlements.polRead,
                            ...apiConfig.entitlements.tgtInternalRead,
                            apiConfig.entitlements.reverseLogisticsUser,
                          ]}
                          renderUnauthorized={() => <Unauthorized />}
                        >
                          <Main />
                        </ProtectedElement>
                      </Router>
                    </QueryClientProvider>
                  </ToastProvider>
                </JoyrideProvider>
              </GlobalProvider>
              <UpdatesNotification />
            </UpdatesAvailableProvider>
          </AnalyticsProvider>
        </AuthProvider>
      </EnvProvider>
      <OfflineDialog />
    </ErrorBoundary>
  )
}
export default App
